var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageHeader',{attrs:{"has-return":"","page":{
      icon: 'fas fa-file-user',
      title: 'Información del Estudiante (MiPE)',
      routes: ['Inicio', 'Información del Estudiante (MiPE)'],
    }}}),_c('StudentInformation',{attrs:{"student-sie-id":_vm.studentSieId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }